import React from "react";
import { AgendamientoResumido } from "../../services/agendamientosServicios";
import { ResumenAgendamiento } from "../agendamientoResumido/ResumenAgendamiento";
import { Accordion } from "react-bootstrap";
import { SeccionMascota } from "./SeccionMascota";

export const AgendamientosResumidos = ({
  agendamientos,
}: {
  agendamientos: AgendamientoResumido[];
}) => {
  const agendamientosPorMascota = agruparAgendamientos(agendamientos);

  if (agendamientos.length === 1) {
    return <ResumenAgendamiento agendamientoResumido={agendamientos[0]} />;
  }

  return (
    <Accordion defaultActiveKey={"0"} className="mb-4">
      {Object.entries(agendamientosPorMascota).map((entry, index) => {
        const agendamientos = entry[1];
        const mascota = agendamientos[0].mascota;
        return (
          <Accordion.Item eventKey={index.toString()} key={mascota}>
            <Accordion.Header>
              <h4 className="mb-3" style={{ fontWeight: 500 }}>
                {mascota}
              </h4>
            </Accordion.Header>
            <Accordion.Body>
              <SeccionMascota
                agendamientos={agendamientos}
              />
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

const agruparAgendamientos = (
  agendamientoResumidos: AgendamientoResumido[]
): Record<string, AgendamientoResumido[]> => {
  let agendamientosPorMascota: Record<string, AgendamientoResumido[]> = {};
  agendamientoResumidos.forEach((agendamientoResumido) => {
    const agendamientosDeMascota =
      agendamientosPorMascota[agendamientoResumido.mascota];
    if (!agendamientosDeMascota) {
      agendamientosPorMascota[agendamientoResumido.mascota] =
        Array.of(agendamientoResumido);
    } else {
      agendamientosPorMascota[agendamientoResumido.mascota].push(
        agendamientoResumido
      );
    }
  });

  return agendamientosPorMascota;
};
